<div class="d-flex flex-column h-100 overflow-hidden">
  <div class="px-5">
    <div class="col px-0">
      <h3 class="everheader my-4">Manage Users</h3>
    </div>
  </div>
  <div class="d-flex flex-column overflow-hidden px-5">
    <div class="col px-0">
      <div class="d-flex mb-3">
        <mat-form-field class="align-self-center editor-search">
          <mat-icon matIconPrefix class="mat-evericon mr-2">search</mat-icon>
          <input
            matInput
            (keyup)="applyFilter($event)"
            (input)="applyFilter($event)"
            placeholder="Search Here"
            class="search-input"
            autocomplete="off"
            #inputFilter
          />
          <button
            mat-button
            mat-icon-button
            matSuffix
            (click)="resetSearch(inputFilter)"
            *ngIf="inputFilter.value"
          >
            <mat-icon class="mat-evericon">close</mat-icon>
          </button>
        </mat-form-field>
        <button
          type="button"
          class="align-self-center mx-2 everbtnmain"
          id="createNewUser"
          (click)="newUser()"
        >
          Create User
        </button>
      </div>
    </div>
    <div class="table-container">
      <div class="col px-0">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let element">{{ element.title }}</td>
          </ng-container>

          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>First Name</th>
            <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
          </ng-container>

          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef>Last Name</th>
            <td mat-cell *matCellDef="let element">{{ element.surname }}</td>
          </ng-container>

          <ng-container matColumnDef="emailAddress">
            <th mat-header-cell *matHeaderCellDef>Email Address</th>
            <td mat-cell *matCellDef="let element">
              {{ element.emailAddress }}
            </td>
          </ng-container>

          <ng-container matColumnDef="defaultContactNumber">
            <th mat-header-cell *matHeaderCellDef>Default Contact Number</th>
            <td mat-cell *matCellDef="let element">
              {{ element.defaultContactNumber }}
            </td>
          </ng-container>

          <ng-container matColumnDef="defaultContactExtension">
            <th mat-header-cell *matHeaderCellDef>Extension</th>
            <td mat-cell *matCellDef="let element">
              {{ element.defaultContactExtension }}
            </td>
          </ng-container>

          <ng-container matColumnDef="mfaEnabled">
            <th mat-header-cell *matHeaderCellDef>
              Multi-Factor Authentication
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon class="mfa-icon" [svgIcon]="element.svgIcon"></mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Role</th>
            <td mat-cell *matCellDef="let element">
              {{ getRolesString(element.roles) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRowClick(row)"
            (contextmenu)="onRowContextMenu($event, row)"
            [ngClass]="{ rowSelected: row === selectedRow }"
          ></tr>
        </table>
        <div
          id="noSearchResult"
          class="no-search-result"
          *ngIf="
            inputFilter.value &&
            dataSource &&
            (!dataSource.filteredData || dataSource.filteredData.length === 0)
          "
        >
          No results found
        </div>
      </div>
    </div>
  </div>
  <div
    class="rowContextMenu"
    [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y"
    [matMenuTriggerFor]="contextMenu"
  ></div>
  <mat-menu #contextMenu="matMenu" class="primary-menu">
    <button mat-menu-item (click)="onContextMenuRemoveUser()">
      Remove User
    </button>
  </mat-menu>
</div>
